/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { Tooltip } from "components/general/Tooltip";
import React, { useRef } from "react";
import { useMediaQuery } from "usehooks-ts";
import { ReactComponent as InfoIcon } from "../../img/trade-interface/info.svg";
import { GlobalStore } from "../../store/global/GlobalStore";
import { Amount } from "../../types/amount";
import { Text } from "../general/Text";

export const NetworkFeeLabel: React.FC<{ networkFee: Amount }> = ({ networkFee }) => {
  const network = GlobalStore.useState(s => s.network);
  const matchesMinWidth460Px = useMediaQuery("(min-width: 460px)");
  const infoRef = useRef<HTMLDivElement>(null);
  const theme = GlobalStore.useState(s => s.theme);
  const tooltipText =
    "This fee is known as the network or gas fee and is determined by network demand. It does not go to Bebop.";

  return (
    <span data-testid={"network-fee-label"}>
      <div className={`d-flex gap-1 justify-content-end align-items-center`} ref={infoRef}>
        <Text size="Medium" textStyle="Paragraph" color={theme.font.secondary.default}>
          No extra charges. {!matchesMinWidth460Px ? <br /> : null} {network.name} fee included.{" "}
        </Text>
        <Text
          size="Medium"
          textStyle="Paragraph"
          color={theme.font.tertiary.default}
          textCss={css`
            text-decoration-line: line-through;
          `}
        >
          ${networkFee.value.toFixed(2)}
        </Text>
        <Tooltip title={tooltipText}>
          <InfoIcon width={12} height={12} />
        </Tooltip>
      </div>
    </span>
  );
};
